import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import ModalFooter from '../../../../../components/modal-footer-actions';
import ModalPortal from '../../../../../components/modal-portal';
import { FilterEditorContext } from '../../../../../components/filter-editor/context';
import messages from './messages';
import style from './delete-filter.module.less';

const DeleteFilterModal = ({ orderFilterSetId, closeModal }) => {
  const { onDeleteFilterSet, filterSets } = useContext(FilterEditorContext);
  const filterSet = filterSets[orderFilterSetId];
  const onDeleteFilter = useCallback(async () => {
    await onDeleteFilterSet(orderFilterSetId);
    closeModal();
  }, [orderFilterSetId, onDeleteFilterSet, closeModal]);

  return (
    <ModalPortal containerId='delete-automation-rule-modal' onClose={closeModal}>
      <Modal>
        <ModalHeader closeModal={closeModal}>
          <FormattedMessage {...messages.deleteFilterHeader} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <div>
            <FormattedMessage {...messages.deleteFilterHeaderConfirmation} />
          </div>
          <div className={style.delete}>{filterSet?.name}</div>
        </ModalBody>
        <ModalFooter
          actionMessage={<FormattedMessage {...messages.delete} />}
          actionTheme='danger'
          cancelMessage={<FormattedMessage {...messages.cancel} />}
          onAction={onDeleteFilter}
          onCancel={closeModal}
        />
      </Modal>
    </ModalPortal>
  );
};

DeleteFilterModal.propTypes = {
  orderFilterSetId: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default DeleteFilterModal;
